import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import EngineerVisitIcon from "../../assets/icons/engineer.svg2";

export default function MyTemplateCard({ children, isSelected, onSelect }) {
  return (
    <div className={`my-3 ${isSelected ? "" : "opacity-50"}`}>
      <button
        type="button"
        className={`btn  w-100 h-100 bg-white p-3 text-start rounded-3 position-relative overflow-hidden ${
          isSelected ? "border border-2 border-blue" : ""
        }`}
        onClick={onSelect}
      >
        {isSelected ? (
          <FontAwesomeIcon
            icon={faCheck}
            className="position-absolute top-0 end-0 text-white bg-colored p-2"
            style={{ borderBottomLeftRadius: 8 }}
          />
        ) : null}
        <div className="d-flex align-items-center">
          <div className="bg-purple-gradient rounded-circle me-3">
            <EngineerVisitIcon width={50} />
          </div>
          <div className="me-3">{children} </div>
        </div>
      </button>
    </div>
  );
}
